import { useState, useCallback } from 'react';

export function useFilter() {
  const [ratingFilter, setRatingFilter] = useState(1);
  const [decadeFilter, setDecadeFilter] = useState('all');
  const [genreFilter, setGenreFilter] = useState('all');

  const applyRatingFilter = useCallback((items) => {
    return items.filter((item) => item.vote_average >= ratingFilter);
  }, [ratingFilter]);

  const applyDecadeFilter = useCallback((items) => {
    if (decadeFilter === 'all') {
      return items;
    }

    const startYear = parseInt(decadeFilter);
    const endYear = startYear + 9;

    return items.filter((item) => {
      const releaseDate = item.release_date || item.first_air_date;
      if (!releaseDate) return false;
      
      const releaseYear = parseInt(releaseDate.slice(0, 4));
      return releaseYear >= startYear && releaseYear <= endYear;
    });
  }, [decadeFilter]);

  const applyGenreFilter = useCallback((items) => {
    if (genreFilter === 'all') {
      return items;
    }

    const genreId = parseInt(genreFilter);
    
    // Mapping for combined genres that have different IDs in Movies vs TV
    const getRelatedGenreIds = (id) => {
      if (id === 28) return [28, 10759]; // Action & Adventure
      if (id === 878) return [878, 10765]; // Sci-Fi & Fantasy
      if (id === 27) return [27]; // Horror
      if (id === 53) return [53, 9648]; // Thriller & Mystery
      return [id];
    };

    const targetIds = getRelatedGenreIds(genreId);

    return items.filter((item) => {
      if (!item.genre_ids) return false;
      return item.genre_ids.some(id => targetIds.includes(id));
    });
  }, [genreFilter]);

  const applyFilters = useCallback((items) => {
    let filteredItems = applyRatingFilter(items);
    filteredItems = applyDecadeFilter(filteredItems);
    filteredItems = applyGenreFilter(filteredItems);
    return filteredItems;
  }, [applyRatingFilter, applyDecadeFilter, applyGenreFilter]);

  return {
    ratingFilter,
    setRatingFilter,
    decadeFilter,
    setDecadeFilter,
    genreFilter,
    setGenreFilter,
    applyFilters,
  };
}